import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import md5 from "blueimp-md5";

var canFireEvents = function canFireEvents() {
  return typeof window !== "undefined" && window.digitalData && window.PubSub;
};

export var ensureFormObjectInitialized = function ensureFormObjectInitialized() {
  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  if (!window.digitalData.page.form) {
    window.digitalData.page.form = {};
  }
};
export var populateGtag = function populateGtag(email, tel) {
  var conversionId = document.body.getAttribute("data-conversion-id");

  if (window.gtag && conversionId && email) {
    var userData = _objectSpread({
      email: email
    }, tel && {
      phone_number: tel
    });

    window.gtag("set", "user_data", userData); // eslint-disable-next-line camelcase

    window.gtag("event", "form_submit", {
      send_to: conversionId
    });
  }
};
export var fireFormStart = function fireFormStart(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "" : _ref$type;

  if (canFireEvents()) {
    ensureFormObjectInitialized();
    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;
    window.PubSub.publish("analytics.formStart", {});
  }
};
export var fireFormSubmitSuccess = function fireFormSubmitSuccess(_ref2) {
  var _ref2$hashableIdentif = _ref2.hashableIdentifier,
      hashableIdentifier = _ref2$hashableIdentif === void 0 ? false : _ref2$hashableIdentif,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? "" : _ref2$name,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "" : _ref2$type,
      _ref2$email = _ref2.email,
      email = _ref2$email === void 0 ? "" : _ref2$email,
      _ref2$tel = _ref2.tel,
      tel = _ref2$tel === void 0 ? "" : _ref2$tel;

  if (canFireEvents()) {
    ensureFormObjectInitialized();
    populateGtag(email, tel);
    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;

    if (hashableIdentifier) {
      window.digitalData.page.form.formEmail = md5(hashableIdentifier);
    }

    window.PubSub.publish("analytics.formSuccess", {});
  }
};
export var fireFormSubmitFailure = function fireFormSubmitFailure(_ref3) {
  var _ref3$invalidFieldNam = _ref3.invalidFieldNames,
      invalidFieldNames = _ref3$invalidFieldNam === void 0 ? [] : _ref3$invalidFieldNam,
      _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? "" : _ref3$name,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? "" : _ref3$type;

  if (canFireEvents()) {
    ensureFormObjectInitialized();
    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;
    window.digitalData.page.form.formErrors = invalidFieldNames.join(",");
    window.PubSub.publish("analytics.formErrors", {});
  }
};